export default __webpack_public_path__ + "static/story-explained-3acc0ca0fa8bc6a3fe94279707fe4aa8.svg";